module.exports = __webpack_public_path__ + "img/bg-top2.fe3b27ce.png";